import React__default from 'react';
import PropTypes from 'prop-types';
import { StyledDivider } from './Divider.style.js';

const Divider = _ref => {
  let {
    as = 'div',
    className,
    noMargin,
    variant
  } = _ref;
  return /*#__PURE__*/React__default.createElement(StyledDivider, {
    $noMargin: noMargin,
    $variant: variant,
    as: as,
    className: className
  });
};
Divider.displayName = 'Divider';
Divider.propTypes = {
  /**
   * Element or component used for the root node.
   */
  as: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
  className: PropTypes.string,
  /**
   * Disable default bottom margin.
   */
  noMargin: PropTypes.bool,
  variant: PropTypes.oneOf(['inlineVertical', 'sidebar', 'vertical'])
};

export { Divider };
